const MASS_PAYMENTS_RECIPIENTS_GETTERS = {
  items: 'massPaymentsRecipients/items',
  loading: 'massPaymentsRecipients/loading',
  search: 'massPaymentsRecipients/search',
  sort: 'massPaymentsRecipients/sort',
  page: 'massPaymentsRecipients/page',
  total: 'massPaymentsRecipients/total',
  totalAll: 'massPaymentsRecipients/totalAll',
}

const MASS_PAYMENTS_RECIPIENTS_DISPATCHERS = {
  goToLoadRecipients: 'massPaymentsRecipients/goToLoadRecipients',
  changePage: 'massPaymentsRecipients/changePage',
  onSearch: 'massPaymentsRecipients/onSearch',
  onSelectSort: 'massPaymentsRecipients/onSelectSort',
  resetSearch: 'massPaymentsRecipients/resetSearch',
  resetStore: 'massPaymentsRecipients/resetStore',
}

export {
  MASS_PAYMENTS_RECIPIENTS_GETTERS,
  MASS_PAYMENTS_RECIPIENTS_DISPATCHERS,
}
